export default "<template>\n  <FdTile title=\"Title\" description=\"Description\" />\n</template>"